// Growth lane copy (features 10/16). Astra was not reachable overnight, so these lines were drafted by Opus and gated by
// Claude 10/16 (AGENTS.md: "If Astra is unavailable, Opus covers"): sentence case, no dashes or exclamation marks, no
// jargon, "activities" not "listings", price stated plainly, nothing promised that is not built. Astra to pass over them
// before the friends-and-family round. The QA panel's own labels live in lib/flags.ts (internal tool, not customer copy).
export const FG = {
  // This weekend, for you
  'fg.wk_title': 'This weekend, for you',
  'fg.wk_sub': 'Picks for {range}, chosen for your taste.',
  'fg.wk_entry_title': 'This weekend, for you',
  'fg.wk_entry_body': 'Picks for {range}, chosen for your taste.',
  'fg.wk_entry_cta': 'See the picks',
  'fg.wk_sub_events': 'Most of these are events on this weekend only.',
  'fg.wk_one_off': 'On this weekend',
  'fg.wk_wait_title': 'Your next five arrive Thursday',
  'fg.wk_wait_body': 'Every Thursday we pick five things for the weekend ahead. Until then, Browse has everything.',
  'fg.wk_empty': 'We could not find good picks for this weekend yet. Browse has everything that is on.',
  'fg.wk_browse': 'Go to Browse',
  'fg.wk_error': 'We could not load your weekend picks. Check your connection and try again.',
  'fg.retry': 'Try again',
  // Come with me?
  'fg.come_cta': 'Come with me?',
  'fg.come_help': "Send this to a friend. When they tap I'm in, you can both add it to your calendar.",
  'fg.come_making': 'Making your link',
  'fg.come_shared': 'Link ready. Send it to a friend from your phone.',
  'fg.come_copied': 'Link copied. Paste it in a message to a friend.',
  'fg.come_manual': 'Copy this link and send it to a friend:',
  'fg.come_waiting': 'Waiting for your friend to say yes.',
  'fg.come_in_one': 'A friend is in.',
  'fg.come_in_many': '{count} friends are in.',
  'fg.come_error': 'We could not make the link. Try again.',
  'fg.come_share_title': 'Come with me?',
  'fg.c_kicker': 'A friend wants you to come',
  'fg.c_question': 'Want to go together?',
  'fg.c_in': "I'm in",
  'fg.c_in_done': "You're in. Your friend will see it.",
  'fg.c_add': 'Put it on your calendar',
  'fg.c_mine': 'This is your invite. Send the link to a friend; you will see here when they say yes.',
  'fg.c_mine_in_one': 'A friend said yes.',
  'fg.c_mine_in_many': '{count} friends said yes.',
  'fg.c_expired': 'This invite has expired.',
  'fg.c_bad': 'This invite link does not work.',
  'fg.c_gone': 'This activity is no longer listed.',
  'fg.c_error': 'We could not open this invite. Check your connection and try again.',
  'fg.c_explore': 'See more things to do in LA',
  'fg.c_in_error': 'We could not save that. Try again.',
  // Add to home screen
  'fg.install_title': 'Keep Magellan on your home screen',
  'fg.install_ios': 'Tap Share, then Add to Home Screen. Magellan opens like an app, one tap away.',
  'fg.install_android': 'Add it to your home screen so Magellan is one tap away.',
  'fg.install_cta': 'Add to home screen',
  'fg.install_dismiss': 'Not now',
  // Plus (records interest only; nothing is charged and no payment details are asked)
  'fg.plus_kicker': 'Magellan Plus',
  'fg.plus_title': 'Would you pay $10 a month for Plus?',
  'fg.plus_body': 'We are thinking about a paid plan. Browsing and planning stay free either way.',
  'fg.plus_item_1': 'Reminders before the things you added',
  'fg.plus_item_2': 'Early word on small events before they fill up',
  'fg.plus_item_3': 'Planning together with a partner',
  'fg.plus_join': 'I would join',
  'fg.plus_not_now': 'Not now',
  'fg.plus_note': 'Nothing is charged. This only tells us whether to build it.',
  'fg.plus_thanks_join': 'Thanks. That helps us decide.',
  'fg.plus_thanks_no': 'Thanks for telling us.',
  // Doors to the taste profile space (placeholders; Astra writes the final words)
  'fg.taste_row': 'Your taste',
  'fg.taste_entry': 'Picks not quite you? Tell us more in a minute',
  // R-15: why each plan option sharpens the picks
  'fg.tip_budget': 'Sets which prices we show first. Free things always stay in.',
  'fg.tip_drive': 'Keeps picks within the time you are happy to travel from where you start.',
} as const

export type FgKey = keyof typeof FG
/** A growth lane line, with {placeholders} filled. */
export const fg = (k: FgKey, vars: Record<string, string | number> = {}): string =>
  FG[k].replace(/\{(\w+)\}/g, (m, name: string) => (name in vars ? String(vars[name]) : m))
